import React, { useReducer } from "react";

export const OverdriveApiContext = React.createContext(null);

export const OverdriveApiProvider: React.FC = ({ children }) => {
  const overdriveApiReducer = (state: any, action: any) => {
    return {
      ...state,
      [action.method]: {
        status: action.status,
        data: action.data,
        error: action.error,
      },
    };
  };

  const [state, dispatch] = useReducer(overdriveApiReducer, {});

  return (
    <OverdriveApiContext.Provider value={[state, dispatch]}>
      {children}
    </OverdriveApiContext.Provider>
  );
};
